import { createSlice } from '@reduxjs/toolkit';
import StkUrunTanimAddDTO from 'src/models/StokEczane/UrunTanimlari/StkUrunTanimAddDTO';
import VwStkUrunTanimDTO from 'src/models/StokEczane/UrunTanimlari/VwStkUrunTanimDTO ';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';

interface IUrunTanimState {
  urunTanimList: Array<VwStkUrunTanimDTO>;
  urunTanimDto: StkUrunTanimAddDTO;
  urunDepoDurumOpen: boolean;
  urunDepoHareketlerOpen: boolean;
  urunOrderTalepOpen: boolean;
  urunDepoTalepOpen: boolean;
  aktifDurum:string;
}

const UrunTanimSlice = createSlice<
  IUrunTanimState,
  MapReducerPayloads<
    IUrunTanimState,
    {
      setUrunTanimListState: Array<VwStkUrunTanimDTO>;
      setUrunTanimDto: StkUrunTanimAddDTO;
      setUrunDepoHareketlerOpen: boolean;
      setUrunDepoDurumOpen: boolean;
      setUrunOrderTalepOpen: boolean;
      setUrunDepoTalepOpen: boolean;
      setAktifDurum:string;
    }
  >
>({
  name: 'UrunTanim',
  initialState: {
    urunTanimList: new Array<VwStkUrunTanimDTO>(),
    urunTanimDto: new StkUrunTanimAddDTO(),
    urunDepoDurumOpen: false,
    urunDepoHareketlerOpen: false,
    urunDepoTalepOpen: false,
    urunOrderTalepOpen: false,
    aktifDurum:"1",
  },
  reducers: {
    setUrunTanimListState: (state, action) => {
      state.urunTanimList = action.payload;
    },
    setUrunTanimDto: (state, action) => {
      state.urunTanimDto = action.payload;
    },
    setUrunDepoDurumOpen: (state, action) => {
      state.urunDepoDurumOpen= action.payload
    },
    setUrunDepoHareketlerOpen: (state, action) => {
      state.urunDepoHareketlerOpen = action.payload
    },
    setUrunDepoTalepOpen: (state, action) => {
      state.urunDepoTalepOpen = action.payload
    },
    setUrunOrderTalepOpen: (state, action) => {
      state.urunOrderTalepOpen = action.payload
    },
    setAktifDurum: (state, action) => {
      state.aktifDurum = action.payload
    },
  }
});
export default UrunTanimSlice;
